export default __webpack_public_path__ + "static/media/grandworld1.c78d3848.jpeg";